export const blogPosts = [
  {
    slug: "safer-workplace-culture",
    title: "Creating Safer Workplaces",
    date: "2025-08-07",
    description: "How EthosHub supports the Worker Protection Act...",
    image: "https://images.unsplash.com/photo-1559136656-3db4bf6c35f8?q=80&w=3538&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    featured: false,
  },
  {
    slug: "technology-in-workplace-compliance",
    title: "The Role of Technology in Modern Workplace Compliance",
    date: "2025-08-06",
    description: "Digital tools are revolutionising how companies comply with laws such as the Worker Protection Act, the Public Sector Equality Duty (PSED), the Equality Act 2010, and sector-specific frameworks like the NHS Sexual Safety Charter.",
    image: "https://images.unsplash.com/photo-1557597774-9d273605dfa9?q=80&w=1726&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    featured: false,
  },
  {
    slug: "role-of-technology",
    title: "Why Anonymous Reporting Matters",
    date: "2025-08-05",
    description: "Empower employees to report safely.",
    image: "https://images.unsplash.com/photo-1627330248289-cd404120b2bf?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    featured: false,
  },
  {
    slug: "replacing-outdated-grievance-processes",
    title: "Modern Reporting Tools Are Replacing Outdated Grievance Processes and Here’s Why ",
    date: "2025-08-04",
    description: "In too many UK organisations, outdated grievance procedures remain the first (and often only) channel for employees to raise serious concerns. These rigid, paper-based or HR-only processes may have worked a decade ago, but they’re no longer fit for purpose",
    image: "https://plus.unsplash.com/premium_photo-1705091310871-eac4ca9a06b7?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    featured: true,
  },
  {
    slug: "staff-handbook-is-missing",
    title: "What Your Staff Handbook Is Missing",
    date: "2025-11-14",
    description: "Most organisations have a staff handbook. Many have a grievance policy. But very few have reporting pathways that employees actually trust, or use.",
    image: "https://plus.unsplash.com/premium_photo-1705091310871-eac4ca9a06b7?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    featured: false,
  },  
];